import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TBLUser } from '../app-modules/dashboard/models/tbluser.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from 'src/app/services/service.service';
import { NgbCustomDateParserService } from 'src/app/formatters/ngb-custom-date-parser.service';
import { DatePipe } from '@angular/common';
import { BOLFilter } from './bol-filter.model';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-bill-of-lading',
  templateUrl: './bill-of-lading.component.html',
  styleUrls: ['./bill-of-lading.component.css'],
  animations: [
    trigger('slideToggle', [
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      state('open', style({ height: '*', opacity: 1 })),
      transition('closed <=> open', animate('500ms ease-in-out'))
    ])
  ]
})
export class BillOfLadingComponent implements OnInit {

      selectRoutes = false;
      public size: number = 100;
      public page: number = 0;
      public logon: any = "";
      public scac : any = "";
      public drsStartDate : any;
      public drsEndDate : any;
      users: any;
      billofladingDTOs: any[] = [];
      showDatePicker: boolean = false;
    
      bolFilter: BOLFilter = new BOLFilter();
      selected_date: string = '';
    
      selectedRecord: TBLUser;
      selectedItem: any;
      showOverlay = false;
      billOfLadingList: any;
      selectedDevice: any = {};
      selectedDealer: any = {};
      selectedBillType: any = {};
      selectedProduct: any = {};

      isDatePickerDisabled: boolean = true;
      isScacInvalid: boolean = false;
  
    constructor(private route: ActivatedRoute,
        private router: Router,
        private service: ServiceService,
        public ngbCustomDateParserService: NgbCustomDateParserService,
        private cdr: ChangeDetectorRef,
        private datePipe: DatePipe,
      ) { 
  
        }
  
    ngOnInit(): void {
    }
  
    submitMethod(){
      if (!this.bolFilter.scac) {
        // alert('Please input scac, bolid and hit submit button to view billoflading/routesheet.');
        this.validateScac();
        return;
      }
  
      // Check if at least one of the optional fields is filled
      if (!this.bolFilter.bolId && !this.bolFilter.routeId && !this.bolFilter.driverId && !this.bolFilter.logon && !this.bolFilter.fname && !this.bolFilter.lname) {
        alert('Please input scac, bolid and hit submit button to view billoflading/routesheet.');
        return;
      }

      $(".overlay-loading").show();

      if (this.bolFilter.selectedDate) {
        const jsDate = new Date(this.bolFilter.selectedDate.year, this.bolFilter.selectedDate.month - 1, this.bolFilter.selectedDate.day);
        this.selected_date = this.datePipe.transform(jsDate, 'yyyy-MM-dd');
        this.selected_date = this.selected_date + " 00:00:00";
        this.bolFilter.selectedDateText = this.selected_date;
      }
      
      this.service.getBolDetails(this.bolFilter, this.page, this.size).subscribe(res => {
        
        $(".overlay-loading").hide();
        this.users = res;
        this.billofladingDTOs = this.users?.billofladingDTOs;
        console.log("this.users", this.users);
        this.cdr.detectChanges();
      }, error => {
        $(".overlay-loading").hide();
        console.log(error);
      });
  }
  
  nextBtnClick(incr) {
    this.page = +this.page + incr;
    this.submitMethod();
  }
  
  formatDateForDisplay(date) {
    return this.ngbCustomDateParserService.format(date);
  }
  
  closeDatePicker = false;

    
  public redirectToEditScreen(selectedLoad?: any): void {
    localStorage.setItem('selectedLoad', JSON.stringify(selectedLoad));
    this.router.navigate(['load-details/add-edit/loadDetails/true'], {state: {load:selectedLoad}});
  }
  
  public redirectToDriverScreen(selectedLoad?: any): void {
    
    this.service.getTblUsersByLogon(selectedLoad?.driverDTO?.logon, selectedLoad?.scac).subscribe(res => {
      this.selectedRecord = res;
      $(".overlay-loading").hide();
    }, error => {
      $(".overlay-loading").hide();
      console.log(error);
    });
  
  }
  
  public redirectToBolScreen(selectedLoad?: any): void {
    
    this.service.getBolFromDrsDetails(selectedLoad?.routeId, selectedLoad?.driverDTO?.scac, this.page, this.size).subscribe(res => {
      $(".overlay-loading").hide();
      this.billOfLadingList = res.map(bol => ({ ...bol, showDetails: false }));
    }, error => {
      $(".overlay-loading").hide();
      console.log(error);
    });
  }
  
  getCommaSeparatedValues(items: any[], key: string): string {
    // remove all the duplicate values from the array
    items = items.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t[key] === item[key]
      ))
    );
    return items.map(item => item[key]).join(', ');
  }
  
  openDeviceModal(device: any): void {
    this.selectedDevice = device;
  }

  openDealerModal(dealer: any): void {
    this.selectedDealer = dealer;
  }

  openBillTypeModal(billtype: any): void {
    this.selectedBillType = billtype;
  }

  openProductModal(product: any): void {
    this.selectedProduct = product;
  }

  // onInputChange(field: string) {
  //   if (!this.bolFilter.scac) {
  //     alert('Please enter SCAC before filling other fields.');
  //     this.bolFilter[field] = ''; // Clear the field
  //     return;
  //   }

  //   const optionalFields = ['bolId', 'routeId', 'driverId', 'logon', 'fname', 'lname'];

  //   const filledFields = optionalFields.filter(key => this.bolFilter[key]);

  //   optionalFields.forEach(key => {
  //     const inputField = document.getElementById(key) as HTMLInputElement;
  //     if (inputField) {
  //       inputField.disabled = filledFields.length > 0 && !this.bolFilter[key];
  //     }
  //   });
  //   this.isDatePickerDisabled = (!(this.bolFilter.driverId && this.bolFilter.scac) || !(this.bolFilter.logon && this.bolFilter.scac) || !(this.bolFilter.fname && this.bolFilter.lname && this.bolFilter.scac));
  // }

  onInputChange(field: string) {
    if (!this.bolFilter.scac) {
      alert('Please enter SCAC before filling other fields.');
      this.bolFilter[field] = ''; // Clear the field
      return;
    }

    const optionalFields = ['bolId', 'routeId', 'driverId', 'logon', 'fname', 'lname'];

    const filledFields = optionalFields.filter(key => this.bolFilter[key]);

    optionalFields.forEach(key => {
      const inputField = document.getElementById(key) as HTMLInputElement;
      if (inputField) {
        inputField.disabled = filledFields.length > 0 && !this.bolFilter[key];
      }
    });

    if (this.bolFilter.fname) {
      const lnameField = document.getElementById('lname') as HTMLInputElement;
      if (lnameField) {
        lnameField.disabled = false;
      }
    }

    if (this.bolFilter.lname) {
      const fnameField = document.getElementById('fname') as HTMLInputElement;
      if (fnameField) {
        fnameField.disabled = false;
      }
    }

    this.isDatePickerDisabled = !(
      (this.bolFilter.driverId && this.bolFilter.scac) || 
      (this.bolFilter.logon && this.bolFilter.scac) || 
      (this.bolFilter.fname && this.bolFilter.lname && this.bolFilter.scac)
    );
    
    if (this.bolFilter.logon || (this.bolFilter.fname && this.bolFilter.lname)) {
      this.isDatePickerDisabled = false;
    }
}


  chooseStatus(status: number) {
    var statusText = "";
    if (status < 10) {
      statusText = "Order Received";
    } if (status < 12 && status >= 10) {
      statusText = "Dispatched";
    } else if (status == 12) {
      statusText = "En Route"
    } else if (status == 20) {
      statusText = "At Rack"
    } else if (status == 22) {
      statusText = "Left Rack"
    } else if (status == 24) {
      statusText = "At Location"
    } else if (status >= 26) {
      statusText = "Finished"
    }
    return statusText;
  }

  selectRoute(scacRoute: any) {
    let selectedLoad = scacRoute?.selectedRoute;
    this.bolFilter.scac = scacRoute?.scac;
    if(this.bolFilter && selectedLoad){
    this.selectRoutes = false;
    this.bolFilter.routeId = selectedLoad?.routeId;
    this.submitMethod();
    }
  }

  toggleRoutes() {
    this.selectRoutes = !this.selectRoutes;
  }

  validateScac() {
    this.isScacInvalid = !this.bolFilter.scac.trim(); 
  }

}
